<template>
	<div>
		<loading v-if="!loaded" />
		<div class="md-layout" v-if="loaded">
			<div class="md-layout-item md-small-size-100 md-size-100">
				<h3>Sensor Information</h3>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-100 text-right">
				<span class="late">* required</span>
			</div>
			<div class="md-layout">
				<div class="md-layout-item md-small-size-100 md-size-100">
					<md-field>
						<label>Sensor Name *</label>
						<md-input type="text" v-model="sensor.name"></md-input>
					</md-field>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-50">
					<md-field>
						<label>Sensor Type *</label>
						<md-select placeholder="Sensor Type *" v-model="sensor.sensor_type_id">
							<md-option v-for="sensor_type in sensorTypeList" :value="sensor_type.id" v-if="sensor_type.id > 1">{{sensor_type.name}}</md-option>
						</md-select>
					</md-field>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-50">
					<md-field>
						<label>Data Column *</label>
						<md-select placeholder="Data Column *" v-model="sensor.data_column">
							<md-option value="2">2</md-option>
							<md-option value="3">3</md-option>
							<md-option value="4">4</md-option>
							<md-option value="5">5</md-option>
							<md-option value="6">6</md-option>
							<md-option value="7">7</md-option>
						</md-select>
					</md-field>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-100">
					<md-field>
						<label>Sensor Description *</label>
						<md-input type="text" v-model="sensor.description"></md-input>
					</md-field>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-100">
					<label>Sensor Location *</label>
					<Map :latitude="sensor.lat" :longitude="sensor.lng" style="height: 300px"
						@locationUpdated="locationUpdated">
					</Map>
				</div>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-50">
				<div class="md-layout-item md-small-size-100 md-size-100">
					<h3>Summary</h3>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-100">
					<md-table>
						<md-table-row>
							<md-table-cell style="width: 50%;">Sensor Name</md-table-cell>
							<md-table-cell style="width: 5px">:</md-table-cell>
							<md-table-cell>
								<span v-if="String(sensor.name).length > 0">{{sensor.name}}</span>
								<span v-else>N/A</span>
							</md-table-cell>
						</md-table-row>
						<md-table-row>
							<md-table-cell>Sensor Type</md-table-cell>
							<md-table-cell>:</md-table-cell>
							<md-table-cell>
								<span v-if="String(sensor.sensor_type_id).length > 0">{{getSensorType}}</span>
								<span v-else>N/A</span>
							</md-table-cell>
						</md-table-row>
						<md-table-row>
							<md-table-cell>Data Column</md-table-cell>
							<md-table-cell>:</md-table-cell>
							<md-table-cell>
								<span v-if="String(sensor.data_column).length > 0">{{sensor.data_column}}</span>
								<span v-else>N/A</span>
							</md-table-cell>
						</md-table-row>
						<md-table-row>
							<md-table-cell>Sensor Latitude</md-table-cell>
							<md-table-cell>:</md-table-cell>
							<md-table-cell>
								<span v-if="sensor.lat != 0">{{sensor.lat}}</span>
								<span v-else>N/A</span>
							</md-table-cell>
						</md-table-row>
						<md-table-row>
							<md-table-cell>Sensor Longtiude</md-table-cell>
							<md-table-cell>:</md-table-cell>
							<md-table-cell>
								<span v-if="sensor.lng != 0">{{sensor.lng}}</span>
								<span v-else>N/A</span>
							</md-table-cell>
						</md-table-row>

					</md-table>
				</div>
			</div>
			<div class="md-layout-item md-size-100 text-right">
				<md-button class="md-raised md-primary" @click="updateSensor()">Update</md-button>
			</div>
		</div>
	</div>
	</div>

</template>

<script>
	import Map from 'vue-google-maps-location-selector';
	import { Datetime } from 'vue-datetime';
	export default {
		components: { Datetime, Map },
		created() {
			// this.getStation();
			this.getSettings();
			this.getSensor();
		},

		data() {
			return {
				loaded: false,
				sensor: {
					name: "",
					lat: "",
					lng: "",
					sensor_type_id: "",
					data_column: "",
					description: ""
				},
				stationArray: "",
				stationList: [],
				sensorTypeList: []
			}
		},
		watch: {
			'stationArray': function (val) {
				if (String(this.stationArray).length > 5) {
					this.sensor.station_id = this.stationArray.id;
				} else {
					this.sensor.station_id = "";
				}
			}
		},
		computed: {
			getSensorType() {
				let name = "";
				for(let i =0 ; i< this.sensorTypeList.length ;i++) {
					if(this.sensor.sensor_type_id == this.sensorTypeList[i].id) {
						return this.sensorTypeList[i].name;
					}
				}
				return "N/A"
			},
		},
		methods: {
			locationUpdated(latLng) {
				this.sensor.lat = latLng.lat;
    			this.sensor.lng = latLng.lng;
			},
			getSettings() {
				this.$http.get(this.config.api + "/admin/setting/data/get_all").then(data => {
					this.sensorTypeList = data.body.data.sensor_type;
				})
			},
			getSensor() {
				this.$http.get(this.config.api + '/admin/sensor/get/' + this.$route.params.hash_id).then(data => {
					this.sensor = data.body.data
					this.sensor.data_column = data.body.data.value_column
					this.loaded = true
					// for(let i =0; i< this.stationList.length; i++) {
					// 	if(this.sensor.station_id == this.stationList[i].id) {
					// 		this.stationArray = this.stationList[i];
					// 		this.loaded = true
					// 	}
					// }
				})
			},
			updateSensor() {
				if (!this.checkValidation()) return false;
				this.$http.post(this.config.api + "/admin/sensor/update", {
					sensor_hash_id: this.$route.params.hash_id,
					sensor: this.sensor
				}).then(data => {
					if (data.body.status == 'success') {
						this.tabName = 'first'
						this.$notification.notify({
							message: "Sensor was updated successfully.",
							icon: 'done',
							type: 'success'
						});
					}
					this.$router.push("/sensors");

				})
			},
			checkValidation() {
				if (String(this.sensor.station_id).length > 0 && String(this.sensor.name).length > 0 && String(this.sensor.data_save_frequency).length > 0 && String(this.sensor.data_column).length > 0 && String(this.sensor.sensor_type_id).length > 0) {
					return true;
				} else {
					this.$notification.notify({
						message: "Please fill in information",
						icon: 'info',
						type: 'warning'
					});
					return false;
				}
			},
			clearAll() {
				this.client = {
					id: "",
					name: "",
					phone: "",
					description: ""
				}
			}
		}
	}
</script>
<style scoped>
	.product-thumbnail {
		width: 64px;
		height: 64px;
	}

	.grid-8 {
		text-align: center;
		max-width: 20%;
		min-width: 20%;
		flex: 0 0 20%;
	}

	.thumb-product {
		width: 50%;
	}
</style>



// WEBPACK FOOTER //
// src/pages/Sensors/Edit.vue